import styled from 'styled-components';
import { Colors } from '../constants/colors';

export const StyledMenuLink = styled.a`
  text-decoration: none;
  font-weight: 600;
  color: ${Colors.white};
`;
